(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-yakchew"] && !Shopify.designMode) return;
  try {
    
  class CollectionYC extends HTMLElement {
    connectedCallback() {
      // instant filtering: submit the filter form whenever a filter changes
      const form = this.querySelector('[data-col-form]');
      if (form) form.addEventListener('change', () => form.submit());
      const sort = this.querySelector('[data-col-sort]');
      if (sort) sort.addEventListener('change', () => { const f = sort.form; if (f) f.submit(); });
      const open = this.querySelector('[data-col-filters-open]');
      const close = this.querySelector('[data-col-filters-close]');
      const overlay = this.querySelector('[data-col-overlay]');
      const toggle = (on) => this.classList.toggle('is-filters-open', on);
      open && open.addEventListener('click', () => toggle(true));
      close && close.addEventListener('click', () => toggle(false));
      overlay && overlay.addEventListener('click', () => toggle(false));
    }
  }
  if (!customElements.get('collection-yc')) customElements.define('collection-yc', CollectionYC);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-yakchew"] && !Shopify.designMode) return;
  try {
    
  class ContactFormYC extends HTMLElement {
    connectedCallback() {
      this.postUrl = (this.dataset.postUrl || '').trim();
      this.form = this.querySelector('form');
      this.status = this.querySelector('.cf__status');
      this.submitBtn = this.querySelector('.cf__submit');
      if (this.form) this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      // clear a field's error as the user types
      this.querySelectorAll('.cf__input').forEach((input) => {
        input.addEventListener('input', () => this.clearError(input.name));
      });
    }

    fieldEl(name) { return this.querySelector('[name="' + name + '"]'); }
    setError(name, message) {
      const el = this.fieldEl(name);
      if (!el) return;
      el.closest('.cf__field').classList.add('is-error');
      const err = this.querySelector('[data-error-for="' + name + '"]');
      if (err) err.textContent = message;
    }
    clearError(name) {
      const el = this.fieldEl(name);
      if (!el) return;
      el.closest('.cf__field').classList.remove('is-error');
      const err = this.querySelector('[data-error-for="' + name + '"]');
      if (err) err.textContent = '';
    }

    validate() {
      const data = {};
      this.querySelectorAll('.cf__input').forEach((el) => {
        data[el.name] = el.value.trim();
        this.clearError(el.name);
      });
      let ok = true;
      let firstBad = null;

      if (!data.name) { this.setError('name', 'Please enter your name.'); ok = false; firstBad = firstBad || 'name'; }
      if (!data.email) {
        this.setError('email', 'Please enter your email address.'); ok = false; firstBad = firstBad || 'email';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
        this.setError('email', 'Please enter a valid email address.'); ok = false; firstBad = firstBad || 'email';
      }
      if (data.phone && !/^[0-9+()\-\s]{6,}$/.test(data.phone)) {
        this.setError('phone', 'Please enter a valid phone number.'); ok = false; firstBad = firstBad || 'phone';
      }
      if (!data.message) { this.setError('message', 'Please enter a message.'); ok = false; firstBad = firstBad || 'message'; }

      if (firstBad) { const f = this.fieldEl(firstBad); if (f) f.focus(); }
      return ok ? data : null;
    }

    setStatus(msg, kind) {
      if (!this.status) return;
      this.status.textContent = msg || '';
      this.status.classList.remove('is-ok', 'is-err');
      if (kind) this.status.classList.add(kind === 'ok' ? 'is-ok' : 'is-err');
    }

    handleSubmit(e) {
      e.preventDefault();
      this.setStatus('', null);
      const data = this.validate();
      if (!data) return;

      const payload = { ...data, submitted_at: new Date().toISOString() };

      if (!this.postUrl) {
        // No POST URL configured — log the submission to the console.
        console.log('[Contact form] submission:', payload);
        this.onSuccess();
        return;
      }

      this.submitBtn.disabled = true;
      this.setStatus('Sending…', null);
      fetch(this.postUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(() => this.onSuccess())
        .catch((err) => {
          console.error('[Contact form] submit failed:', err);
          this.setStatus('Sorry, something went wrong. Please try again.', 'err');
        })
        .finally(() => { this.submitBtn.disabled = false; });
    }

    onSuccess() {
      this.setStatus(this.dataset.successText || 'Thanks! Your message has been sent.', 'ok');
      this.form.reset();
    }
  }
  if (!customElements.get('contact-form-yc')) customElements.define('contact-form-yc', ContactFormYC);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-yakchew-plus"] && !Shopify.designMode) return;
  try {
    
  function ycInitHeader(root) {
    if (root.dataset.ycReady === 'true') return;
    root.dataset.ycReady = 'true';

    var promo = root.querySelector('[data-yc-promo]');
    if (promo) {
      var setPromoHeight = function () {
        root.style.setProperty('--yc-promo-h', promo.offsetHeight + 'px');
      };
      setPromoHeight();
      window.addEventListener('resize', setPromoHeight);
    }

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-yc-flyout]'));
    var closeTimer;

    function panelOf(trigger) {
      return root.querySelector('#' + trigger.getAttribute('aria-controls'));
    }

    function closePanel(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      var panel = panelOf(trigger);
      if (panel) panel.removeAttribute('data-open');
    }

    function closeAll() {
      triggers.forEach(closePanel);
    }

    function openPanel(trigger) {
      closeAll();
      trigger.setAttribute('aria-expanded', 'true');
      var panel = panelOf(trigger);
      if (panel) panel.setAttribute('data-open', '');
    }

    triggers.forEach(function (trigger) {
      var panel = panelOf(trigger);
      var group = trigger.parentElement;
      if (!panel) return;

      trigger.addEventListener('click', function () {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          closePanel(trigger);
        } else {
          openPanel(trigger);
        }
      });

      group.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openPanel(trigger);
      });

      group.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 140);
      });

      panel.addEventListener('focusin', function () {
        clearTimeout(closeTimer);
      });

      group.addEventListener('focusout', function (event) {
        if (!group.contains(event.relatedTarget)) closePanel(trigger);
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.yc-primary')) closeAll();
    });

    var searchToggle = root.querySelector('[data-yc-search-toggle]');
    var searchRow = root.querySelector('[data-yc-search]');

    if (searchToggle && searchRow) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchRow.hasAttribute('data-open');
        if (isOpen) {
          searchRow.removeAttribute('data-open');
          searchToggle.setAttribute('aria-expanded', 'false');
        } else {
          searchRow.setAttribute('data-open', '');
          searchToggle.setAttribute('aria-expanded', 'true');
          var field = searchRow.querySelector('input[type="search"]');
          if (field) field.focus();
        }
      });
    }

    var drawer = root.querySelector('[data-yc-drawer]');
    var scrim = root.querySelector('[data-yc-scrim]');
    var burger = root.querySelector('[data-yc-burger]');
    var drawerClose = root.querySelector('[data-yc-drawer-close]');

    function shutDrawer() {
      if (!drawer) return;
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.removeAttribute('data-open');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
      document.body.style.overflow = '';
    }

    if (burger && drawer) {
      burger.addEventListener('click', function () {
        drawer.setAttribute('data-open', '');
        drawer.setAttribute('aria-hidden', 'false');
        if (scrim) scrim.setAttribute('data-open', '');
        burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        if (drawerClose) drawerClose.focus();
      });
    }

    if (drawerClose) drawerClose.addEventListener('click', shutDrawer);
    if (scrim) scrim.addEventListener('click', shutDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openTrigger = root.querySelector('[data-yc-flyout][aria-expanded="true"]');
      if (openTrigger) {
        closePanel(openTrigger);
        openTrigger.focus();
      }
      if (drawer && drawer.hasAttribute('data-open')) shutDrawer();
    });

    root.querySelectorAll('[data-yc-acc] > button').forEach(function (button) {
      button.addEventListener('click', function () {
        var row = button.parentElement;
        var wasOpen = row.hasAttribute('data-open');
        root.querySelectorAll('[data-yc-acc]').forEach(function (item) {
          item.removeAttribute('data-open');
          item.querySelector('button').setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          row.setAttribute('data-open', '');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function ycInitAll(scope) {
    (scope || document).querySelectorAll('[data-yc-head]').forEach(ycInitHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ycInitAll(document);
    });
  } else {
    ycInitAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    ycInitAll(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-yakchew"] && !Shopify.designMode) return;
  try {
    
  class ProductInfoYC extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-piy-variants]').textContent);
      } catch (e) { this.variants = []; }
      this.idInput = this.querySelector('input[name="id"]');
      this.firstMediaId = this.dataset.firstMedia;
      this.slides = Array.from(this.querySelectorAll('[data-piy-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-piy-thumb]'));
      const atcWrap = this.querySelector('[data-piy-atc-wrap]');
      this.atcDefaultText = (atcWrap && atcWrap.dataset.default) || 'Add to Cart';
      this.soldOutText = (atcWrap && atcWrap.dataset.soldout) || 'Sold out';

      this.bindGallery();
      this.bindThumbSlider();
      this.bindQuantity();
      this.bindOptions();
      this.bindAddToCartLoader();
      this.updateFromSelection(false);
    }

    /* ---- add-to-cart loading spinner (until the cart line update resolves) ---- */
    bindAddToCartLoader() {
      const btn = this.querySelector('.piy-atc');
      if (!btn) return;
      // Match the Collection tabs / cards: skip Horizon's fly-to-cart animation so
      // the cart drawer opens immediately after loading instead of ~1.6s later.
      const atcComp = this.querySelector('add-to-cart-component');
      if (atcComp) atcComp.dataset.addToCartAnimation = 'false';
      const setLoading = (on) => {
        btn.classList.toggle('is-loading', on);
        if (on) {
          clearTimeout(this._atcTimer);
          this._atcTimer = setTimeout(() => btn.classList.remove('is-loading'), 8000);
        } else {
          clearTimeout(this._atcTimer);
        }
      };
      btn.addEventListener('click', () => { if (!btn.disabled) setLoading(true); });
      this.addEventListener('shopify:cart:lines-update', (e) => {
        if (e.action && e.action !== 'add') return;
        const done = () => setLoading(false);
        if (e.promise && typeof e.promise.finally === 'function') e.promise.finally(done);
        else done();
      });
    }

    /* ---- gallery ---- */
    showMedia(mediaId) {
      if (mediaId == null) return;
      let matched = false;
      this.slides.forEach((s) => {
        const on = String(s.dataset.mediaId) === String(mediaId);
        s.classList.toggle('is-active', on);
        if (on) matched = true;
        // pause any video that scrolls out
        if (!on) { const v = s.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } }
      });
      this.thumbs.forEach((t) => t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId)));
      if (this._scrollThumbIntoView) this._scrollThumbIntoView(mediaId);
      return matched;
    }
    bindGallery() {
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.showMedia(t.dataset.mediaId)));
      const play = this.querySelector('[data-piy-play]');
      if (play) {
        play.addEventListener('click', () => {
          const vid = this.slides.find((s) => s.dataset.type === 'video' || s.dataset.type === 'external_video');
          if (vid) {
            this.showMedia(vid.dataset.mediaId);
            const v = vid.querySelector('video'); if (v) { try { v.play(); } catch (e) {} }
          }
        });
      }
    }

    /* ---- thumbnail slider ---- */
    bindThumbSlider() {
      const wrap = this.querySelector('[data-piy-thumbs-wrap]');
      const strip = this.querySelector('[data-piy-thumbs]');
      const stage = this.querySelector('.piy__stage');
      const up = this.querySelector('[data-piy-thumb-up]');
      const down = this.querySelector('[data-piy-thumb-down]');
      if (!wrap || !strip || !stage) return;

      // Desktop only: cap the vertical thumbnail column to the main image height
      // so extra thumbnails scroll inside it instead of running down the page.
      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
      const syncHeight = () => {
        if (isMobile()) { strip.style.maxHeight = ''; return; }
        strip.style.maxHeight = stage.offsetHeight + 'px';
      };
      const step = () => {
        const t = strip.querySelector('.piy__thumb');
        if (!t) return 200;
        const gap = parseFloat(getComputedStyle(strip).rowGap) || 12;
        return (t.offsetHeight + gap) * 2;
      };
      const update = () => {
        const scrollable = !isMobile() && strip.scrollHeight - strip.clientHeight > 4;
        wrap.classList.toggle('is-scrollable', scrollable);
        if (up) up.disabled = !scrollable || strip.scrollTop <= 2;
        if (down) down.disabled = !scrollable || strip.scrollTop >= strip.scrollHeight - strip.clientHeight - 2;
      };
      const refresh = () => { syncHeight(); update(); };

      up && up.addEventListener('click', () => strip.scrollBy({ top: -step(), behavior: 'smooth' }));
      down && down.addEventListener('click', () => strip.scrollBy({ top: step(), behavior: 'smooth' }));
      strip.addEventListener('scroll', update, { passive: true });

      // keep the active thumb visible when it changes
      this._scrollThumbIntoView = (mediaId) => {
        const t = strip.querySelector('[data-media-id="' + mediaId + '"]');
        if (t && !isMobile()) t.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      };

      refresh();
      this.querySelectorAll('.piy__stage img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', refresh, { once: true });
      });
      let rt;
      window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(refresh, 150); });
      window.addEventListener('load', refresh);
    }

    /* ---- quantity ---- */
    bindQuantity() {
      const input = this.querySelector('[data-piy-qty-input]');
      if (!input) return;
      const clamp = () => { let n = parseInt(input.value, 10); if (isNaN(n) || n < 1) n = 1; input.value = n; };
      this.querySelector('[data-piy-qty-minus]')?.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      this.querySelector('[data-piy-qty-plus]')?.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
      input.addEventListener('change', clamp);
    }

    /* ---- options ---- */
    bindOptions() {
      this.querySelectorAll('[data-piy-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.closest('[data-piy-option-group]');
          group.querySelectorAll('[data-piy-value]').forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this.updateFromSelection(true);
        });
      });
    }
    selectedOptions() {
      const groups = Array.from(this.querySelectorAll('[data-piy-option-group]'));
      return groups.map((g) => {
        const sel = g.querySelector('[data-piy-value].is-selected');
        return sel ? sel.dataset.value : null;
      });
    }
    findVariant(opts) {
      return this.variants.find((v) => v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
    }

    updateFromSelection(userInitiated) {
      const groups = Array.from(this.querySelectorAll('[data-piy-option-group]'));
      if (!groups.length) return; // single-variant product: keep server-rendered state

      // current selection, one value per option group
      const sel = groups.map((g) => {
        const s = g.querySelector('[data-piy-value].is-selected');
        return s ? s.dataset.value : null;
      });

      // Cascade left -> right: an EARLIER option (e.g. Size) constrains the LATER
      // one (e.g. Pack). For each value we check whether a variant exists for the
      // current earlier selection:
      //   · no variant at all  -> deleted combo -> hide it entirely
      //   · variant exists, all out of stock -> show but mark sold out
      groups.forEach((g, gi) => {
        const btns = Array.from(g.querySelectorAll('[data-piy-value]'));
        const matchesEarlier = (vr) => {
          for (let j = 0; j < gi; j++) {
            if (sel[j] != null && vr.options[j] !== sel[j]) return false;
          }
          return true;
        };
        btns.forEach((btn) => {
          const v = btn.dataset.value;
          const exists = this.variants.some((vr) => vr.options[gi] === v && matchesEarlier(vr));
          const inStock = this.variants.some((vr) => vr.options[gi] === v && vr.available && matchesEarlier(vr));
          btn.classList.toggle('is-hidden', !exists);
          btn.classList.toggle('is-soldout', exists && !inStock);
        });
        // if this group's selected value is no longer valid (hidden), auto-pick one
        let selBtn = btns.find((b) => b.dataset.value === sel[gi] && !b.classList.contains('is-hidden'));
        if (!selBtn) {
          selBtn = btns.find((b) => !b.classList.contains('is-hidden') && !b.classList.contains('is-soldout'))
                || btns.find((b) => !b.classList.contains('is-hidden'));
          btns.forEach((b) => b.classList.remove('is-selected'));
          if (selBtn) { selBtn.classList.add('is-selected'); sel[gi] = selBtn.dataset.value; }
          else { sel[gi] = null; }
        }
      });

      const variant = sel.every((s) => s != null) ? this.findVariant(sel) : null;
      if (!variant) { this.setAvailability(false, this.soldOutText); return; }

      // sync hidden id + url
      if (this.idInput) this.idInput.value = variant.id;
      if (userInitiated) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }
      // price
      const priceEl = this.querySelector('[data-piy-price]');
      if (priceEl) priceEl.textContent = variant.price;
      const compEl = this.querySelector('[data-piy-compare]');
      if (compEl) {
        if (variant.compare) { compEl.textContent = variant.compare; compEl.hidden = false; }
        else { compEl.hidden = true; }
      }
      // image: variant image if it has one, else the product's first image
      if (!this.showMedia(variant.media_id)) this.showMedia(this.firstMediaId);
      // availability -> add-to-cart + badge
      this.setAvailability(variant.available);
    }

    setAvailability(available, forcedText) {
      // stock badge
      const badge = this.querySelector('[data-piy-badge]');
      if (badge) {
        badge.classList.toggle('is-out', !available);
        const t = badge.querySelector('[data-piy-badge-text]');
        if (t) t.textContent = available ? badge.dataset.in : badge.dataset.out;
      }
      // add-to-cart button
      const btn = this.querySelector('.piy-atc');
      if (!btn) return;
      btn.disabled = !available;
      const txt = btn.querySelector('.add-to-cart-text__content span span span') || btn.querySelector('.add-to-cart-text__content');
      if (txt) {
        if (forcedText) txt.textContent = forcedText;
        else txt.textContent = available ? this.atcDefaultText : this.soldOutText;
      }
    }
  }
  if (!customElements.get('product-info-yc')) customElements.define('product-info-yc', ProductInfoYC);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-yakchew"] && !Shopify.designMode) return;
  try {
    
  class ProductTabsYC extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ptx-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-ptx-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.ptxTab));
      });
    }
    select(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.ptxTab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        const on = p.dataset.ptxPanel === id;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });
    }
  }
  if (!customElements.get('product-tabs-yc')) customElements.define('product-tabs-yc', ProductTabsYC);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-yakchew"] && !Shopify.designMode) return;
  try {
    

  class RecSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rc-track]');
      this.prev = this.querySelector('[data-rc-prev]');
      this.next = this.querySelector('[data-rc-next]');
      if (!this.track) return;
      this._update = this._update.bind(this);
      this.track.addEventListener('scroll', this._update, { passive: true });
      this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -this._step(), behavior: 'smooth' }));
      this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: this._step(), behavior: 'smooth' }));
      this._onResize = () => { clearTimeout(this._rt); this._rt = setTimeout(this._update, 150); };
      window.addEventListener('resize', this._onResize);
      window.addEventListener('load', this._update);
      this._update();
      requestAnimationFrame(this._update);
    }
    disconnectedCallback() { window.removeEventListener('resize', this._onResize); window.removeEventListener('load', this._update); }
    _step() {
      const c = this.track.querySelector('.rc-card');
      if (!c) return 320;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 24;
      return c.offsetWidth + gap;
    }
    _update() {
      const t = this.track;
      const scrollable = (t.scrollWidth - t.clientWidth) > 4;
      this.classList.toggle('is-scrollable', scrollable);
      if (this.prev) this.prev.disabled = !scrollable || t.scrollLeft <= 2;
      if (this.next) this.next.disabled = !scrollable || t.scrollLeft >= (t.scrollWidth - t.clientWidth - 2);
      // vertically center the arrows on the product image
      const m = this.querySelector('.rc-card__media');
      if (m) {
        const top = (m.getBoundingClientRect().top - this.getBoundingClientRect().top) + m.offsetHeight / 2;
        if (this.prev) this.prev.style.top = top + 'px';
        if (this.next) this.next.style.top = top + 'px';
      }
    }
  }
  if (!customElements.get('rec-slider')) customElements.define('rec-slider', RecSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-grid-yakchew"] && !Shopify.designMode) return;
  try {
    
  class SearchGridYC extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('[data-sgy-form]');
      if (form) form.addEventListener('change', () => form.submit());
      const sort = this.querySelector('[data-sgy-sort]');
      if (sort) sort.addEventListener('change', () => { const f = sort.form; if (f) f.submit(); });
      const open = this.querySelector('[data-sgy-filters-open]');
      const close = this.querySelector('[data-sgy-filters-close]');
      const overlay = this.querySelector('[data-sgy-overlay]');
      const toggle = (on) => this.classList.toggle('is-filters-open', on);
      open && open.addEventListener('click', () => toggle(true));
      close && close.addEventListener('click', () => toggle(false));
      overlay && overlay.addEventListener('click', () => toggle(false));
    }
  }
  if (!customElements.get('search-grid-yc')) customElements.define('search-grid-yc', SearchGridYC);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-blogs-yakchew"] && !Shopify.designMode) return;
  try {
    
  class SimilarBlogsYC extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-esb-track]');
      this.dotsEl = this.querySelector('[data-esb-dots]');
      this.prevBtn = this.querySelector('[data-esb-prev]');
      this.nextBtn = this.querySelector('[data-esb-next]');
      if (!this.track) return;
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.page(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this._ro = new ResizeObserver(() => this.buildDots());
      this._ro.observe(this.track);
      this.buildDots();
    }
    disconnectedCallback() { if (this._ro) this._ro.disconnect(); }
    pages() { return Math.max(1, Math.round(this.track.scrollWidth / this.track.clientWidth)); }
    current() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }
    page(dir) { this.track.scrollBy({ left: dir * this.track.clientWidth * 0.92, behavior: 'smooth' }); }
    buildDots() {
      if (!this.dotsEl) return;
      const n = this.pages();
      this.dotsEl.innerHTML = '';
      if (n <= 1) { this.dotsEl.hidden = true; this.sync(); return; }
      this.dotsEl.hidden = false;
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.className = 'esb-dot';
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' }));
        this.dotsEl.appendChild(b);
      }
      this.sync();
    }
    sync() {
      const cur = this.current();
      if (this.dotsEl) {
        this.dotsEl.querySelectorAll('.esb-dot').forEach((d, i) => d.classList.toggle('is-active', i === cur));
      }
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }
  if (!customElements.get('similar-blogs-yc')) customElements.define('similar-blogs-yc', SimilarBlogsYC);

  } catch(e) { console.error(e); }
})();
})();
